// import React from 'react';
// import { Link } from 'react-router-dom';

// const Footer = () => {
//   const currentYear = new Date().getFullYear();

//   return (
//     <footer
//       className="footer-wrapper footer-layout1"
//       style={{ backgroundImage: `url('/img/bg/footer-bg.jpg')` }}
//     >
      

//       {/* Footer Widget Area */}
//       <div className="widget-area">
//         <div className="container">
//           <div className="row g-5 justify-content-between">
//             {/* About Section */}
//             <div className="col-md-6 col-xl-3">
//               <div className="widget footer-widget">
//                 <div className="vs-widget-about">
//                   {/* <div className="footer-logo">
//                     <a href="#">
//                       <img src="/img/white-logo.svg" alt="Travolo Logo" className="logo" />
//                     </a>
//                   </div> */}
//              <h4 className="brand- text-white">Platinum24 Cabs</h4>
//               <p><strong className="brand-text">Phone:</strong><br />
//                 <a href="tel:+917507048333" className="footer-link">+91 7507048333</a><br />
//               </p>
//               <p><strong className="brand-text">Email:</strong><br />
//                 <a href="mailto:booking@platinum24cab.com" className="footer-link">booking@platinum24cab.com</a>
//               </p>
//               <p><strong className="brand-text">Address:</strong><br />
//                 OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
// FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
//               </p>
//               <div className="mt-4">
//                 <h5 className="brand-text">Our Location:</h5>
              


// <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d186.74118639497098!2d73.84959074263809!3d18.648043339180404!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c7f3bae12abb%3A0x70a5b506b09ceb81!2sAccord%20Hospitals!5e1!3m2!1sen!2sin!4v1758802420974!5m2!1sen!2sin" width="100%" height="250" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

//               </div>
//                 </div>
//               </div>
//             </div>

//             {/* Our Services */}
//             <div className="col-md-6 col-xl-3">
//               <div className="widget widget_nav_menu footer-widget">
//                 <h3 className="widget_title">Our Services</h3>
//                 <div className="menu-all-pages-container">
//                  <Link className="mx-md-2 d-block" to="/pune-cab-service">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune Cab Service
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-taxi-hire">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune Taxi Hire
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-online-cab-booking">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune Online Cab Booking
// </Link>
// <Link className="mx-md-2 d-block" to="/best-cab-service-in-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Best Cab Service in Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-mumbai-cabs">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Mumbai Cabs
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-nashik-cabs">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Nashik Cabs
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-mahabaleshwar-cabs">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Mahabaleshwar Cabs
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-lonavala-cabs">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Lonavala Cabs
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-shirdi-cab">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Shirdi Cab
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-bhimashankar-cab">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Bhimashankar Cab
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-konkan-darshan-cabs">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Konkan Darshan Cabs
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-outstation-cabs">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune Outstation Cabs
// </Link>
// <Link className="mx-md-2 d-block" to="/ashtavinayak-darshan-cab">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Ashtavinayak Darshan Cab
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-goa-cabs">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Goa Cabs
// </Link>
// <Link className="mx-md-2 d-block" to="/cabs-services-near-me">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Cabs Services Near Me
// </Link>
// <Link className="mx-md-2 d-block" to="/corporate-cab-service-in-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Corporate Cab Service in Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-mumbai-airport-cabs">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Mumbai Airport Cabs
// </Link>
// <Link className="mx-md-2 d-block" to="/tempo-traveller-on-rent-in-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Tempo Traveller On Rent in Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/urbania-on-rent-in-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Urbania On Rent in Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/innova-crysta-on-rent-in-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Innova Crysta On Rent in Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/bus-on-rent-in-pimpri-chinchwad">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Bus On Rent in Pimpri Chinchwad
// </Link>
// <Link className="mx-md-2 d-block" to="/mini-bus-on-rent-in-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Mini Bus On Rent in Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/ertiga-on-rent-in-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Ertiga On Rent in Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-sambhaji-nagar-taxi">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Sambhaji Nagar Taxi
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-ganpatipule-taxi">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Ganpatipule Taxi
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-harihareshwar-taxi">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Harihareshwar Taxi
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-alibag-cabs">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Alibag Cabs
// </Link>
// <Link className="mx-md-2 d-block" to="/cab-service-in-viman-nagar">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Cab Service in Viman Nagar
// </Link>
// <Link className="mx-md-2 d-block" to="/cab-service-in-kharadi">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Cab Service in Kharadi
// </Link>
// <Link className="mx-md-2 d-block" to="/taxi-service-in-hinjewadi-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Taxi Service in Hinjewadi Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/travel-agents-in-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Travel Agents in Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/outstation-taxi-service-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Outstation Taxi Service Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-ashtavinayak-darshan-cabs">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Ashtavinayak Darshan Cabs
// </Link>

//                 </div>
//               </div>
//             </div>

//   {/* Our Services */}
//             <div className="col-md-6 col-xl-3">
//               <div className="widget widget_nav_menu footer-widget">
//                 <h3 className="widget_title">Our Services</h3>
//                 <div className="menu-all-pages-container">
            
// <Link className="mx-md-2 d-block" to="/pune-to-sade-teen-shakti-peeth-darshan-cabs">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Sade Teen Shakti Peeth Darshan Cabs
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-akkalkot-cabs">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Akkalkot Cabs
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-tuljapur-cabs">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Tuljapur Cabs
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-pandharpur-cabs">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Pandharpur Cabs
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-gangapur-cabs">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Gangapur Cabs
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-ujjain-omkareshwar-darshan-cabs">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Ujjain Omkareshwar Darshan Cabs
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-jyotirling-darshan-cabs">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Jyotirling Darshan Cabs
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-trimbakeshwar-cabs">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Trimbakeshwar Cabs
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-jejuri-khandoba-temple-cabs">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Jejuri Khandoba Temple Cabs
// </Link>
// <Link className="mx-md-2 d-block" to="/cab-booking-in-pune-for-outstation">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Cab Booking in Pune for Outstation
// </Link>
// <Link className="mx-md-2 d-block" to="/reliable-taxi-service-in-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Reliable Taxi Service in Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/luxury-cars-on-rent-in-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Luxury Cars on Rent in Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/local-sightseeing-cabs-in-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Local Sightseeing Cabs in Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/one-way-taxi-from-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> One Way Taxi from Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/round-trip-cab-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Round Trip Cab Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/weekend-getaway-cabs-from-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Weekend Getaway Cabs from Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/24x7-cab-service-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> 24x7 Cab Service Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-lavasa-cab-service">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Lavasa Cab Service
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-matheran-cabs">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Matheran Cabs
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-satara-cab">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Satara Cab
// </Link>
// <Link className="mx-md-2 d-block" to="/airport-pickup-and-drop-in-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Airport Pickup and Drop in Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/cheapest-cab-service-in-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Cheapest Cab Service in Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-local-cab-booking">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune Local Cab Booking
// </Link>


//   <Link className="mx-md-2 d-block" to="/premium-cab-service-in-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Premium Cab Service in Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-igatpuri-taxi">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Igatpuri Taxi
// </Link>
//                   <Link className="mx-md-2 d-block" to="/pune-to-bhuleshwar-temple-cabs">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Bhuleshwar Temple Cabs
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-sightseeing-taxi">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune Sightseeing Taxi
// </Link>
//             <Link className="mx-md-2 d-block" to="/pune-darshan-cab-booking">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune Darshan Cab Booking
// </Link>
         
// <Link className="mx-md-2 d-block" to="/8-seater-cab-on-rent-in-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> 8-Seater Cab on Rent in Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/sedan-taxi-hire-in-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Sedan Taxi Hire in Pune
// </Link>

//                 </div>
//               </div>
//             </div>

//             {/* Our Services */}
//             <div className="col-md-6 col-xl-3">
//               <div className="widget widget_nav_menu footer-widget">
//                 <h3 className="widget_title">Our Services</h3>
//                 <div className="menu-all-pages-container">
       
// <Link className="mx-md-2 d-block" to="/pune-to-bhandardara-cabs">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Bhandardara Cabs
// </Link>
// <Link className="mx-md-2 d-block" to="/ac-taxi-service-in-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> AC Taxi Service in Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-kolhapur-cabs">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Kolhapur Cabs
// </Link>
// <Link className="mx-md-2 d-block" to="/cab-service-in-wakad-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Cab Service in Wakad Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-pune-airport-taxi">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Pune Airport Taxi
// </Link>
// <Link className="mx-md-2 d-block" to="/outstation-round-trip-cabs-from-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Outstation Round Trip Cabs from Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/local-taxi-hire-in-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Local Taxi Hire in Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-sindhudurg-taxi">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Sindhudurg Taxi
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-ajanta-ellora-cabs">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Ajanta Ellora Cabs
// </Link>
// <Link className="mx-md-2 d-block" to="/daily-office-cab-service-in-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Daily Office Cab Service in Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/cab-service-in-pimpri-chinchwad">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Cab Service in Pimpri Chinchwad
// </Link>
// <Link className="mx-md-2 d-block" to="/taxi-service-in-chakan-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Taxi Service in Chakan Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/cab-service-in-nigdi-pradhikaran">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Cab Service in Nigdi Pradhikaran
// </Link>
// <Link className="mx-md-2 d-block" to="/cab-booking-in-talegaon-dabhade">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Cab Booking in Talegaon Dabhade
// </Link>
// <Link className="mx-md-2 d-block" to="/cab-service-in-akurdi-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Cab Service in Akurdi Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/outstation-cabs-from-pimpri-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Outstation Cabs from Pimpri Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/taxi-from-chikhali-to-mumbai-airport">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Taxi from Chikhali to Mumbai Airport
// </Link>
// <Link className="mx-md-2 d-block" to="/cab-hire-in-bhosari-midc-area">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Cab Hire in Bhosari MIDC Area
// </Link>
// <Link className="mx-md-2 d-block" to="/pickup-drop-cab-service-in-moshi-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pickup Drop Cab Service in Moshi Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/car-rental-in-ravet-pune">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Car Rental in Ravet Pune
// </Link>
// <Link className="mx-md-2 d-block" to="/pune-to-mumbai-darshan-cabs">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Pune to Mumbai Darshan Cabs
// </Link>



// <Link className="mx-md-2 d-block" to="/cab-service-in-bhosari">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Cab Service in Bhosari
// </Link>
// <Link className="mx-md-2 d-block" to="/cab-service-in-moshi">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Cab Service in Moshi
// </Link>
// <Link className="mx-md-2 d-block" to="/cab-service-in-nigdi">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Cab Service in Nigdi
// </Link>
// <Link className="mx-md-2 d-block" to="/cab-service-in-alandi">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Cab Service in Alandi
// </Link>
// <Link className="mx-md-2 d-block" to="/cab-service-in-rajgurunagar">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Cab Service in Rajgurunagar
// </Link>
// <Link className="mx-md-2 d-block" to="/cab-service-in-khed">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Cab Service in Khed
// </Link>
// <Link className="mx-md-2 d-block" to="/cab-service-in-khed-city">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Cab Service in Khed City
// </Link>
// <Link className="mx-md-2 d-block" to="/cab-service-in-bhimashankar">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Cab Service in Bhimashankar
// </Link>
// <Link className="mx-md-2 d-block" to="/cab-service-in-chakan-midc">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Cab Service in Chakan MIDC
// </Link>
// <Link className="mx-md-2 d-block" to="/cab-service-in-manchar">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Cab Service in Manchar
// </Link>
// <Link className="mx-md-2 d-block" to="/cab-service-in-narayangaon">
//   <i className="fa-duotone fa-solid fa-car darkcolor"></i> Cab Service in Narayangaon
// </Link>


//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Copyright */}
//       <div className="container">
//         <div className="copyright-wrap">
//           <div className="row justify-content-between align-items-center">
//             <div className="col-lg-auto">
// <p className="copyright-text">
//             © {new Date().getFullYear()} <span className="brand-text">Platinum24 Cabs</span>. All Rights Reserved. Developed By 
//             <a href="https://www.dexterintelligence.com/" target="_blank" rel="noreferrer" className="footer-link"> Dexter Intelligence</a> | Hosted By 
//             <a href="https://www.urvahosting.com/" target="_blank" rel="noreferrer" className="footer-link"> Urva Hosting</a>
//           </p>
//             </div>
           
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;


import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  // all services keywords in one array
  const services = [
    "Pune Cab Service",
    "Pune Taxi Hire",
    "Pune Online Cab Booking",
    "Best Cab Service in Pune",
    "Pune to Mumbai Cabs",
    "Pune to Nashik Cabs",
    "Pune to Mahabaleshwar Cabs",
    "Pune to Lonavala Cabs",
    "Pune to Shirdi Cab",
    "Pune to Bhimashankar Cab",
    "Pune to Konkan Darshan Cabs",
    "Pune Outstation Cabs",
    "Ashtavinayak Darshan Cab",
    "Pune to Goa Cabs",
    "Cabs Services Near Me",
    "Corporate Cab Service in Pune",
    "Pune to Mumbai Airport Cabs",
    "Tempo Traveller On Rent in Pune",
    "Urbania On Rent in Pune",
    "Innova Crysta On Rent in Pune",
    "Bus On Rent in Pimpri Chinchwad",
    "Mini Bus On Rent in Pune",
    "Ertiga On Rent in Pune",
    "Pune to Sambhaji Nagar Taxi",
    "Pune to Ganpatipule Taxi",
    "Pune to Harihareshwar Taxi",
    "Pune to Alibag Cabs",
    "Cab Service in Viman Nagar",
    "Cab Service in Kharadi",
    "Taxi Service in Hinjewadi Pune",
    "Travel Agents in Pune",
    "Outstation Taxi Service Pune",
    "Pune to Ashtavinayak Darshan Cabs",
    "Pune to Sade Teen Shakti Peeth Darshan Cabs",
    "Pune to Akkalkot Cabs",
    "Pune to Tuljapur Cabs",
    "Pune to Pandharpur Cabs",
    "Pune to Gangapur Cabs",
    "Pune to Ujjain Omkareshwar Darshan Cabs",
    "Pune to Jyotirling Darshan Cabs",
    "Pune to Trimbakeshwar Cabs",
    "Pune to Jejuri Khandoba Temple Cabs",
    "Cab Booking in Pune for Outstation",
    "Reliable Taxi Service in Pune",
    "Luxury Cars on Rent in Pune",
    "Local Sightseeing Cabs in Pune",
    "One Way Taxi from Pune",
    "Round Trip Cab Pune",
    "Weekend Getaway Cabs from Pune",
    "24x7 Cab Service Pune",
    "Pune to Lavasa Cab Service",
    "Pune to Matheran Cabs",
    "Pune to Satara Cab",
    "Airport Pickup and Drop in Pune",
    "Cheapest Cab Service in Pune",
    "Pune Local Cab Booking",
    "Premium Cab Service in Pune",
    "Pune to Igatpuri Taxi",
    "Pune to Bhuleshwar Temple Cabs",
    "Pune Sightseeing Taxi",
    "Pune Darshan Cab Booking",
    "8-Seater Cab on Rent in Pune",
    "Sedan Taxi Hire in Pune",
    "Pune to Bhandardara Cabs",
    "AC Taxi Service in Pune",
    "Pune to Kolhapur Cabs",
    "Cab Service in Wakad Pune",
    "Pune to Pune Airport Taxi",
    "Outstation Round Trip Cabs from Pune",
    "Local Taxi Hire in Pune",
    "Pune to Sindhudurg Taxi",
    "Pune to Ajanta Ellora Cabs",
    "Daily Office Cab Service in Pune",
    "Cab Service in Pimpri Chinchwad",
    "Taxi Service in Chakan Pune",
    "Cab Service in Nigdi Pradhikaran",
   
    "Cab Service in Akurdi Pune",
    
    "Car Rental in Ravet Pune",
    "Pune to Mumbai Darshan Cabs",
    "Cab Service in Bhosari",
    "Cab Service in Moshi",
    "Cab Service in Nigdi",
    "Cab Service in Alandi",
    "Cab Service in Rajgurunagar",
    "Cab Service in Khed",
    "Cab Service in Khed City",
    "Cab Service in Bhimashankar",
    "Cab Service in Chakan MIDC",
    "Cab Service in Manchar",
    "Cab Service in Narayangaon",
    "Pune to Gujarat Cabs", 
    "Pune to Jaipur Cabs",
     "Pune to Hyderabad Cab", 
     "Pune to Rajasthan Cab", 
     "Pune to Indore Cab", 
     "Pune to Bengaluru Cabs", 
     "Pune to Ahmedabad Cab Service",
      "Pune to Vadodara Cab Taxi",
       "Pune to Ayodhya Cab Packages",
        "Pune to Tirupati Cabs Service", 
        "Pune to Chennai Cab Booking",
         "Pune to Surat Cab Service",
          "Pune to Kerala Cabs", 
          "Pune to Jammu Kashmir Cabs",
           "Pune to Jaisalmer Cab", 
           "Pune to Somnath Jyotiling Cabs",
            "Pune to Rameshwaram Cab", 
            "Pune to Hubli Cab Service", 
            "Pune to Telangana Cab Booking", 
            "Pune to Jaipur Taxi Service",
 "Cab Booking in Talegaon Dabhade",

 "Outstation Cabs from Pimpri Pune",
    "Taxi from Chikhali to Mumbai Airport",
    "Cab Hire in Bhosari MIDC Area",
    "Pickup Drop Cab Service in Moshi Pune",
  ];

  // split into 3 equal columns
  const perCol = Math.ceil(services.length / 3);
  const cols = [
    services.slice(0, perCol),
    services.slice(perCol, perCol * 2),
    services.slice(perCol * 2),
  ];

  return (
    <footer className="footer-wrapper" style={{ background: "#0a2a55", color: "#fff" }}>
      <div className="container pt-5">
        <div className="row g-4">
          {/* About/Contact Section */}
          <div className="col-md-3">
            <h4 className="text-white">Platinum24 Cabs</h4>
            <p>
              <strong className="brand-text">Phone:</strong><br />
              <a href="tel:+917507048333" className="footer-link text-white">+91 7507048333</a>
            </p>
            <p>
              <strong className="brand-text">Email:</strong><br />
              <a href="mailto:booking@platinum24cab.com" className="footer-link text-white">booking@platinum24cab.com</a>
            </p>
            <p className="text-white">
              <strong className="brand-text ">Address:</strong><br />
              OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL,<br />
              NEAR ACORD HOSPITAL, FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
            </p>
            <div className="mt-3">
              <h6 className="brand-text">Our Location:</h6>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d186.74118639497098!2d73.84959074263809!3d18.648043339180404!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c7f3bae12abb%3A0x70a5b506b09ceb81!2sAccord%20Hospitals!5e1!3m2!1sen!2sin!4v1758802420974!5m2!1sen!2sin"
                width="100%"
                height="200"
                allowFullScreen=""
                loading="lazy"
                style={{ border: 0 }}
                title="map"
              ></iframe>
            </div>
          </div>

          {/* Services Columns */}
          {cols.map((col, idx) => (
            <div className="col-md-3" key={idx}>
              <h4 style={{ color: "#f15a29" }}>Our Services</h4>
              <ul className="list-unstyled">
                {col.map((s, i) => (
                  <li key={i} style={{ marginBottom: "6px" }}>
                    <i className="fa fa-car" style={{ color: "#f15a29", marginRight: "6px" }}></i>
                    <Link
                      to={"/" + s.toLowerCase().replace(/\s+/g, "-")}
                      style={{ color: "#fff" }}
                    >
                      {s}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Copyright */}
      <div style={{ background: "#081c3d", padding: "12px 0", marginTop: "20px" }}>
        <div className="container text-center">
          <p>
            © {currentYear} <span style={{ color: "#f15a29" }}>Platinum24 Cabs</span>. All Rights Reserved. Developed By{" "}
            <a href="https://www.dexterintelligence.com/" style={{ color: "#f15a29" }} target="_blank" rel="noreferrer">Dexter Intelligence</a> | Hosted By{" "}
            <a href="https://www.urvahosting.com/" style={{ color: "#f15a29" }} target="_blank" rel="noreferrer">Urva Hosting</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
